import { Tag } from "antd";
import { GET_COLOR_BY_SCORE } from "../CampaignReport.constant";
import { useTranslation } from "react-i18next";


const OverAllCard = ({ label, title, desc, data }: { label: string, title: string, desc: string, data: { count: number, label: string, showTag: boolean, cardKey?: string }[] }) => {
    const { t } = useTranslation();

    return <div className="card">
        <div className="card-content">
            <div className="text">
            {/* <div className="label">{label}</div> */}
            <div className="title">{title}</div>
            <div className="description">{desc}</div>
            </div>
            <div className="content-section">
                {data.map((item, idx) => {
                    const itemCount = item.cardKey === "Fail Rate" ? (100 - item.count) : item.count;
                    const { color, bg, tag } = GET_COLOR_BY_SCORE(itemCount);
                    const isSummary = item.cardKey === "SUMMARY";
                    const countTag = `${item.count}${!isSummary ? "%" : ""}`;
                    return <Card {...{ label: item.label, labelColor: isSummary ? "black" : color, cardBg: bg, count: countTag }} tag={item.showTag ? t(tag) : ""} key={idx} />
                })}
            </div>
        </div>
    </div>
}

export default OverAllCard;

const Card = ({ label, count, tag, labelColor, cardBg }: { label?: string, count: string, tag?: string, labelColor: string, cardBg: string }) => {
    return <div className="data-preview-card">
        <div className="data-section">
            {label && <div className="label">{label}</div>}
            <div className={`count ${!label ? "large" : ""}`} style={{ color: labelColor }}>{count}</div>
        </div>
        {tag && <Tag style={{ color: labelColor, background: cardBg }} className="status-tag">{tag}</Tag>}
    </div>
}